import { createSlice } from "@reduxjs/toolkit"

export const initialUserState = {
  auth: false,
  jwt: undefined,
  user: null,
  userType: null, ///ADMIN ,INVESTOR, WEALTH_PARTNER
  permissions: [], ///ADMIN ,INVESTOR, WEALTH_PARTNER
  sidebar: false,
  redirectionUrl: "",
  oldUserType: "",
  isSelfLogout: false,
}

export const userSlice = createSlice({
  name: "user",
  initialState: initialUserState,
  reducers: {
    logoutUser: (state, action) => {
      const { isSelfLogout } = action.payload
      state.auth = false
      state.jwt = undefined
      state.user = null
      state.permissions = []
      // state.userType = null
      state.isSelfLogout = isSelfLogout
      state.oldUserType = isSelfLogout ? state.userType : ""
    },
    setLoginUserData: (state, action) => {
      const {
        user = null,
        jwt = null,
        auth = null,
        userType = null,
        permissions = [],
      } = action?.payload || {}

      state.user = user ?? state.user
      state.jwt = jwt ?? state.jwt
      state.auth = auth ?? state.auth
      state.userType = userType ?? state.userType
      state.permissions = permissions ?? state.permissions
      state.isSelfLogout = false
    },
    setAvatar: (state, action) => {
      const { avatar } = action.payload
      state.user = { ...state.user, avatar }
    },
    setSidebar: (state, action) => {
      const { sidebar } = action.payload
      state.sidebar = sidebar
    },
    setRedirectionUrl: (state, action) => {
      const { url } = action.payload
      state.redirectionUrl = url
    },
  },
})

// Action creators are generated for each case reducer function
export const {
  logoutUser,
  setLoginUserData,
  setAvatar,
  setSidebar,
  setRedirectionUrl,
} = userSlice.actions

export default userSlice.reducer
